module.exports = __webpack_public_path__ + "static/img/banner-loudspeaker.f9e8712.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/banner-loudspeaker.png
// module id = 05N5
// module chunks = 1